import { LeafCheckgroup } from "./checkgroup.component.js";
customElements.define("leaf-checkgroup", LeafCheckgroup);
export {
  LeafCheckgroup
};
//# sourceMappingURL=checkgroup.js.map
